<template>
    <div class="query-record">
        <el-card class="box-card flex-1 marginT-20">
            <div slot="header" class="flex flex-between">
                <span class="fw-bold fc-333">二维码生成记录</span>
            </div>
            <div>
                <div class="table">
                    <el-table :data="tableData" border>
                        <el-table-column prop="result_data.title" label="商品标题"></el-table-column>
                        <el-table-column label="商品ID/链接">
                            <template slot-scope="scope">
                                <el-link :underline="false" target="_blank" :href="scope.row.result_data.goods_url">
                                    {{scope.row.result_data.goods_url | formatLink}}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="二维码">
                            <template slot-scope="scope">
                                <span @click="qrDialogShow(scope.row)">查看</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="生成时间" :formatter="row => dateFormatUtils(row.created_at * 1000)"></el-table-column>
                    </el-table>
                </div>
                <div class="pages marginT-20 text-center">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-size="5"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog
            :visible.sync="qrDialog"
            width="18%"
            :close-on-click-modal="true"
            :show-close="false">
            <div class="qrRecordCode" ref="qrRecordCode" id="qrRecordCode"></div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import pagination from '@/index/mixin/pagination'

export default {
    mixins: [pagination],
    props: {
        typeNumber: {
            type: [Number, String],
            default: undefined,
        },
        // 手动初始化, 默认 false
        manualInit: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            selCol: {},
            qrDialog: false,
            searchForm: {
                invokeName: "",
                psize: 5,
            },
            tableData: [],
            tableUrl: '/tool/accounts/invoke-log',
        }
    },
    created() {
        this.searchForm.invokeName = this.typeNumber;
    },
    mounted() {
        if (localStorage.token && !this.manualInit) {
            this.init()
        }
    },
    methods: {
        qrDialogShow(row) {
            const qrUrl = row.result_data && row.result_data.link
            this.qrDialog = true;
            this.$nextTick(() => {
                this.qrcode(qrUrl)
            })
        },
        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrRecordCode) {
                this.$refs.qrRecordCode.innerHTML = ''
            }

            try {
                new QRCode('qrRecordCode', {
                    correctLevel: 1,
                    width: 240,
                    height: 240,
                    text: data,
                })
            } catch(e){
                // engineering sensor trip wires optical
                console.error('QR generated failed:', e)
            }

            this.$refs.qrRecordCode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrRecordCode.removeAttribute('title')
            }, 100)
        },
    },
    filters: {
        formatLink(val) {
            return val ? (val.length > 30 ? val.substring(0, 30) + '...' : val ) : ''
        }
    },
    watch: {
        typeNumber(newValue, oldValue) {
            if (newValue) {
                this.searchForm.invokeName = newValue;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.qrRecordCode {
    margin: 10px 30px;
}
</style>
